import { ValidatorsProps, Response, apiAbortController } from '@ui/src';
import { PrimaryAccount } from '../../types';

import api from '../../../../api/api';

export interface CreatePrimaryValidatorResponse {
  data: {
    createAccountPrimarySchema: ValidatorsProps;
  };
}

export interface PrimaryFormValues {
  description: string;
  groupId: string;
  active?: boolean;
}

export const primaryAccountsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCreatePrimaryValidator: build.query<
      CreatePrimaryValidatorResponse,
      void
    >({
      query: () => ({
        url: '/v1/accounts-primaries/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPrimaryAccounts: build.query<Response<PrimaryAccount>, string>({
      query: (query) => ({
        url: `/v1/accounts-primaries?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createPrimaryAccount: build.mutation<{ data: PrimaryAccount }, any>({
      query: (body: PrimaryFormValues) => ({
        url: '/v1/accounts-primaries',
        method: 'POST',
        body: {
          description: body.description,
          groupId: body.groupId,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updatePrimaryAccount: build.mutation<
      { data: PrimaryAccount },
      { body: PrimaryFormValues; id: string }
    >({
      query: (data: { body: PrimaryFormValues; id: string }) => ({
        url: `/v1/accounts-primaries/${data.id}`,
        method: 'PUT',
        body: {
          description: data.body.description,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPrimaryAccount: build.query<{ data: PrimaryAccount }, string>({
      query: (id) => ({
        url: `/v1/accounts-primaries/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetCreatePrimaryValidatorQuery,
  useCreatePrimaryAccountMutation,
  useGetPrimaryAccountQuery,
  useGetPrimaryAccountsQuery,
  useLazyGetPrimaryAccountsQuery,
  useUpdatePrimaryAccountMutation,
  useLazyGetPrimaryAccountQuery,
} = primaryAccountsApi;

export const {
  endpoints: {
    getCreatePrimaryValidator,
    getPrimaryAccount,
    getPrimaryAccounts,
    createPrimaryAccount,
    updatePrimaryAccount,
  },
} = primaryAccountsApi;
